import { ScreenBase } from "@frui.ts/screens";
import { action, computed } from "mobx";
import ChargeTypesService from "services/chargeTypesService";
import LocalizationService from "services/localizationService";
import ChargeValidity, { validityDays } from "entities/chargeValidity";
import LanguageCode from "models/languageCode";

export const ChargeTypesModuleNavigationName = "charge_types";

export default class ChargeTypesViewModel extends ScreenBase {
  @computed
  get isInitialized() {
    return this.chargeTypesService.isInitialized;
  }

  get isCSLocale() {
    return this.localizationService.locale === "cs";
  }

  @computed
  get currency() {
    return this.isCSLocale ? "Kč" : "CZK";
  }

  @action.bound
  chargeTypes() {
    return this.chargeTypesService.validChargeTypes
      .sort((a, b) => {
        return validityDays(b.validFor) - validityDays(a.validFor);
      })
      .filter(x => this.chargeTypesService.hasPrices(x))
      .map(x => this.chargeTypesService.populatePrices(x));
  }

  get eshopUrl() {
    return this.localizationService.translateGeneral("eshopRedirect", undefined, true);
  }

  constructor(private chargeTypesService: ChargeTypesService, private localizationService: LocalizationService) {
    super();
  }

  chargeTypeDescription(validFor: ChargeValidity) {
    return this.localizationService.translateAttribute("chargeType", validFor);
  }

  translate(code: string) {
    return this.localizationService.translateGeneral(`chargeTypes.${code}`);
  }

  formatPrice(price: number) {
    return this.localizationService.formatPrice(price);
  }

  formatEcoPriceRange(minPrice: number, maxPrice: number) {
    if (minPrice === maxPrice) {
      return this.localizationService.formatPrice(maxPrice);
    }
    if (this.localizationService.languageCode === LanguageCode.En) {
      // English language uses the "CZK 500 - 600" format.
      return `${this.localizationService.formatPrice(minPrice)} – ${this.localizationService.formatNumber(maxPrice)}`;
    }
    // Other languages use the "500 - 600 Kc" format.
    return `${this.localizationService.formatNumber(minPrice)} – ${this.localizationService.formatPrice(maxPrice)}`;
  }
}
